<template>
  <div>
    <el-tooltip
        v-if="['new'].includes(status)"
        :content="statusMessages[status]"
        placement="top"
    >
      <el-tag type="warning">Novo</el-tag>
    </el-tooltip>

    <el-tooltip
        v-if="['risk_analysis', 'bank_account', 'acquirers', 'gateway'].includes(status)"
        :content="statusMessages[status]"
        placement="top"
    >
      <el-tag type="warning">
        <span>
          Processando
        </span>
      </el-tag>
    </el-tooltip>

    <el-tooltip
        v-if="['risk_analysis_error', 'bank_account_error', 'acquirers_error', 'gateway_error'].includes(status)"
        :content="statusMessages[status]"
        placement="top"
    >
      <el-tag type="danger">Erro</el-tag>
    </el-tooltip>

    <el-tooltip
        v-if="['risk_analysis_reproved', 'risk_analysis_rejected', 'bank_account_reproved', 'acquirers_reproved','gateway_reproved'].includes(status)"
        :content="statusMessages[status]"
        placement="top"
    >
      <el-tag type="danger">Reprovado</el-tag>
    </el-tooltip>

    <el-tooltip
        v-if="['plan_reproved', 'terminal_reproved'].includes(status)"
        :content="statusMessages[status]"
        placement="top"
    >
      <el-tag type="danger">Aguardando Associação</el-tag>
    </el-tooltip>

    <el-tooltip
        v-if="['risk_analysis_manually'].includes(status)"
        :content="statusMessages[status]"
        placement="top"
    >
      <el-tag type="warning">Análise Manual</el-tag>
    </el-tooltip>

    <el-tooltip
        v-if="['risk_analysis_awaiting'].includes(status)"
        :content="statusMessages[status]"
        placement="top"
    >
      <el-tag type="warning">Aguardando Documentação</el-tag>
    </el-tooltip>


    <el-tooltip
        v-if="['risk_analysis_approved', 'bank_account_approved', 'acquirers_approved', 'gateway_approved'].includes(status)"
        :content="statusMessages[status]"
        placement="top"
    >
      <el-tag type="success">Aprovado</el-tag>
    </el-tooltip>

    <el-tooltip
        v-if="['active'].includes(status)"
        :content="statusMessages[status]"
        placement="top"
    >
      <el-tag type="success">
        <span v-if="isBeneficiary">
          Ativo
        </span>
        <span v-else>
          Credenciamento Finalizado
        </span>
      </el-tag>
    </el-tooltip>

    <el-tooltip
        v-if="['cancelled'].includes(status)"
        :content="statusMessages[status]"
        placement="top"
    >
      <el-tag type="danger">Cancelado</el-tag>
    </el-tooltip>

    <el-tooltip
        v-if="['inactive'].includes(status)"
        :content="statusMessages[status]"
        placement="top"
    >
      <el-tag type="danger">Inativo</el-tag>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "StatusCapta",
  props: {
    status: {
      type: String,
      required: true,
    },
    bank_account_reproved: {
      type: String,
    },
    isBeneficiary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statusMessages: {
        "risk_analysis": "Cadastro enviado para a análise de risco! Aguarde o processamento automático.",
        "risk_analysis_error": "Erro interno no sistema. Acione nosso suporte para mais esclarecimentos.",
        "risk_analysis_reproved": `O cadastro não foi aprovado na análise de risco. ${this.isBeneficiary ? '' : 'Para esclarecimentos, entre em contato com seu gestor comercial ou com o suporte.'}`,
        "risk_analysis_awaiting": "Estamos aguardando o envio das informações conforme solicitação por e-mail e chamado aberto.",
        "risk_analysis_rejected": "O cadastro não foi aprovado na análise de risco. Para esclarecimentos, entre em contato com seu gestor comercial ou com o suporte.",
        "risk_analysis_manually": `Foi necessário realizar uma análise manual. Isso significa que vamos pesquisar mais informações sobre o ${this.isBeneficiary ? 'beneficiário' : 'EC'} e caso sejam necessários documentos comprobatórios, em breve solicitaremos a você.`,
        "bank_account": "Cadastro enviado para a validação de domicílio bancário! Aguarde o processamento.",
        "bank_account_error": "Erro interno no sistema. Acione nosso suporte para mais esclarecimentos.",
        "bank_account_reproved": this.bank_account_reproved,
        "plan_reproved": `O plano não foi associado ao ${this.isBeneficiary ? 'beneficiário' : 'estabelecimento'}. Para avançar para a etapa de Gateway, certifique-se de realizar essa associação.`,
        "terminal_reproved": `Por favor, associe um terminal ao ${this.isBeneficiary ? 'beneficiário' : 'estabelecimento'} para finalizar o processo de credenciamento.`,
        "acquirers": "Cadastro enviado para a adquirente! Aguarde o processamento.",
        "acquirers_error": "Erro interno no sistema. Acione nosso suporte para mais esclarecimentos.",
        "acquirers_reproved": "Cadastro rejeitado pela adquirente. Por favor, entre em contato com o seu gestor comercial obter esclarecimentos.",
        "gateway": "Configurando o ambiente de transações! Aguarde a conclusão.",
        "gateway_reproved": `${this.isBeneficiary ? 'Beneficiário' : 'Estabelecimento'} reprovado. Entre em contato com nosso suporte.`,
        "gateway_error": "Erro interno no sistema. Acione nosso suporte para mais esclarecimentos.",
        "inactive": "Beneficiário inativo",
        "active": this.isBeneficiary? `Ativação concluída! Agora o beneficiário está pronto para receber splits!` : `Credenciamento concluído! Agora o estabelecimento está pronto para realizar transações!`,
        "cancelled": "Cadastro cancelado. Por favor, entre em contato com nosso suporte para obter esclarecimentos."
      },
    };
  },
};
</script>

<style scoped></style>